import { render, staticRenderFns } from "./ServicePromotionView.vue?vue&type=template&id=e9f68860"
import script from "./ServicePromotionView.vue?vue&type=script&lang=js"
export * from "./ServicePromotionView.vue?vue&type=script&lang=js"
import style0 from "./ServicePromotionView.vue?vue&type=style&index=0&id=e9f68860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports